import { render, staticRenderFns } from "./Tokyo.vue?vue&type=template&id=d58a41f0&"
import script from "./Tokyo.vue?vue&type=script&lang=js&"
export * from "./Tokyo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports